// Track relevant things about application state.
$(function() {
	window.$body = $('body');
	window.$window = $(window);

	var mobileWidth = 1024;

	function handleFirstTab(e) {
		if (e.keyCode === 9) { // the "I am a keyboard user" key
			document.body.classList.add('user_is_tabbing');
			window.removeEventListener('keydown', handleFirstTab);
		}
	}

	window.addEventListener('keydown', handleFirstTab);

	$window.resize(function() {
		if ($(window).width() > mobileWidth) {
			window.is_mobile = false;
		} else {
			window.is_mobile = true;
		}
	}).trigger('resize');

});